export enum TotaliserType {
    REVENUE = 'REVENUE',
    PROFIT = 'PROFIT',
}
